export default "__VITE_ASSET__De_IXlFO__"